import Vue from 'vue'
import { queryAllUser } from '@/api/screen'

export function useMention() {
  const state = Vue.observable({
    mentionVisible: false,
    mentionKeyword: '',
    mentionActiveIdx: 0,
    mentionAnchorPos: -1,
    filteredUsers: [],
    loading: false
  })

  let requestPending = false
  let blurTimer = null
  let debounceTimer = null

  const clearBlurTimer = () => {
    if (blurTimer) { clearTimeout(blurTimer); blurTimer = null }
  }

  const clearDebounceTimer = () => {
    if (debounceTimer) { clearTimeout(debounceTimer); debounceTimer = null }
  }

  const loadUsers = async (keyword) => {
    if (requestPending) return
    requestPending = true
    state.loading = true
    try {
      const res = await queryAllUser(keyword)
      if (res && res.code === 200) {
        state.filteredUsers = res.data || []
      } else {
        state.filteredUsers = []
      }
    } catch (err) {
      state.filteredUsers = []
    } finally {
      requestPending = false
      state.loading = false
    }
  }

  const detectMention = (value, cursorPos) => {
    const textBefore = value.slice(0, cursorPos)
    const lastAtIdx = textBefore.lastIndexOf('@')

    if (lastAtIdx === -1) {
      clearDebounceTimer()
      closeMention()
      return
    }

    const query = textBefore.slice(lastAtIdx + 1)

    // @后面包含空格或换行，说明@提及已结束
    if (query.includes(' ') || query.includes('\n')) {
      clearDebounceTimer()
      closeMention()
      return
    }

    state.mentionAnchorPos = lastAtIdx
    state.mentionKeyword = query
    state.mentionActiveIdx = 0
    state.mentionVisible = true

    // 防抖：300ms内只发最后一次请求
    clearDebounceTimer()
    debounceTimer = setTimeout(() => {
      loadUsers(query)
    }, 500)
  }

  const closeMention = () => {
    clearBlurTimer()
    clearDebounceTimer()
    state.loading = false
    state.mentionVisible = false
    state.mentionKeyword = ''
    state.mentionActiveIdx = 0
    state.mentionAnchorPos = -1
    state.filteredUsers = []
  }

  const scheduleClose = () => {
    if (!state.mentionVisible) return
    clearBlurTimer()
    blurTimer = setTimeout(() => { closeMention() }, 150)
  }

  const selectUser = (user) => {
    clearBlurTimer()
    clearDebounceTimer()
    const name = user.trueName || user.userName
    const displayName = `@${name} `
    const result = {
      anchorPos: state.mentionAnchorPos,
      displayName,
      cursorAfter: state.mentionAnchorPos + displayName.length
    }
    closeMention()
    return result
  }

  const moveUp = () => { state.mentionActiveIdx = Math.max(0, state.mentionActiveIdx - 1) }

  const moveDown = () => {
    state.mentionActiveIdx = Math.min(state.filteredUsers.length - 1, state.mentionActiveIdx + 1)
  }

  const confirmSelection = () => {
    if (!state.mentionVisible || state.filteredUsers.length === 0) return null
    return selectUser(state.filteredUsers[state.mentionActiveIdx])
  }

  return {
    state,
    loadUsers,
    detectMention,
    closeMention,
    scheduleClose,
    selectUser,
    moveUp,
    moveDown,
    confirmSelection
  }
}
